import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useLang } from '../lib/LanguageContext';

const PageHeader = ({ title, subtitle, crumbs = [] }) => {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden border-b-2 border-[#C9A86A] bg-[#0B2545] py-16 text-white">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'radial-gradient(circle at 15% 30%, #C9A86A 0%, transparent 35%), radial-gradient(circle at 85% 70%, #C9A86A 0%, transparent 35%)'
        }}
      />
      <div className="relative mx-auto max-w-[1280px] px-6">
        {crumbs.length > 0 && (
          <nav className="mb-4 flex flex-wrap items-center gap-1.5 text-[12.5px] text-white/70">
            <Link to="/" className="hover:text-[#C9A86A]">
              {t('Home')}
            </Link>
            {crumbs.map((c, i) => (
              <React.Fragment key={i}>
                <ChevronRight size={13} className="text-white/40" />
                {c.to ? (
                  <Link to={c.to} className="hover:text-[#C9A86A]">
                    {c.label}
                  </Link>
                ) : (
                  <span className="text-[#C9A86A]">{c.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        <h1 className="font-serif text-3xl font-bold leading-tight md:text-[44px]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-3 max-w-2xl text-[15px] text-white/80">{subtitle}</p>
        )}
        <div className="mt-5 h-[3px] w-16 bg-[#C9A86A]" />
      </div>
    </section>
  );
};

export default PageHeader;
